import React, { useMemo } from "react";
import { Box, VStack, Text, SimpleGrid, Stat, StatLabel, StatNumber } from "@chakra-ui/react";
import { useStore } from "../contexts/StoreContext";
import PageShell from "../layout/PageShell";

const cardProps = {
  p: 6,
  bg: "white",
  borderRadius: "lg",
  border: "1px solid",
  borderColor: "#d5e4ea",
  boxShadow: "sm",
};

const Dashboard: React.FC = () => {
  const { allStores } = useStore();

  const stats = useMemo(() => {
    const activeStoresCount = allStores.filter((s) => s.subscriptionStatus === "active").length;

    return [
      { label: "Total Stores", value: allStores.length },
      { label: "Active Stores", value: activeStoresCount },
      { label: "Total Revenue", value: "$0" },
      { label: "Orders (30 Days)", value: "0" },
    ];
  }, [allStores]);

  return (
    <PageShell
      title="Dashboard"
      description="Stores, subscriptions, and activity across the platform."
      wide
    >
      <VStack spacing={6} align="stretch">
        <SimpleGrid columns={{ base: 1, md: 2, xl: 4 }} spacing={4}>
          {stats.map((stat) => (
            <Box key={stat.label} {...cardProps}>
              <Stat>
                <StatLabel color="gray.600">{stat.label}</StatLabel>
                <StatNumber fontWeight="600">{stat.value}</StatNumber>
              </Stat>
            </Box>
          ))}
        </SimpleGrid>

        <Box {...cardProps}>
          <Text fontSize="md" fontWeight="600" mb={2}>
            Charts
          </Text>
          <Text color="gray.600" fontSize="sm">
            Sales value and orders charts will be implemented here.
          </Text>
        </Box>
      </VStack>
    </PageShell>
  );
};

export default Dashboard;
